<template>
  <multiselect
    v-if="visible"
    v-model="selected"
    :placeholder="placeholder"
    :internal-search="false"
    :options="results"
    :searchable="true"
    :loading="isLoading"
    :options-limit="20"
    :max-height="600"
    :custom-label="customLabel"
    @search-change="asyncFindApi"
    @select="onSelect"
    @open="hideOthers"
    @close="showOthers"
  />
</template>

<script>
import { sync } from 'vuex-pathify';

import multisearch from '@/mixins/multisearch';
import debounce from '@/mixins/debounce';

export default {
  mixins: [
    multisearch, //
    debounce, //
  ],

  data() {
    return {
      type: 'playlist',
      placeholder: 'Playlist Search',
    };
  },

  computed: {
    ...sync([
      'webamp/playlist', //
    ]),
  },

  mounted() {
    if (this.playlist.length > 0) {
      this.selected = {
        playlist: this.playlist,
      };
    }
  },

  methods: {
    onSelect(option) {
      // console.log('onSelect', option);
      this.$store.set('webamp/playlist', option.playlist);
      Bus.$emit('songs:fetch', {
        playlist: option.playlist,
      });
      Bus.$emit('searches:clear', 'playlist');
    },

    customLabel(option) {
      // console.log('customLabel', option);
      return $('<div/>').html(option.playlist).text();
    },

    asyncFindApi(query) {
      this.debounce(() => {
        // console.log('asyncFindApi.query', query);
        this.results = [];
        this.isLoading = true;

        this.$http.get('/api/v1/search/playlists', { params: { query } }).then((res) => {
          // console.log('res.data', res.data);
          this.results = res.data;
          this.isLoading = false;
        });
      }, 200);
    },
  },
};
</script>
